import {roundFloat} from "./index";

/**
 * Проверяет, является ли строка координатами в форматах "широта, долгота" или "широта долгота"
 * @param {string} str - Строка для проверки
 * @returns {boolean} - true если строка является валидными координатами
 */
export function isValidCoordinates(str) {
  if (typeof str !== 'string') return false;

  // Пробуем оба формата
  return isValidCommaFormat(str) || isValidSpaceFormat(str);
}

/** return {GeoPoint} */
export function parseCoordinates(str) {
  if (isValidCommaFormat(str)) {
    const parts = str.split(',');
    const lat = roundFloat(parseFloat(parts[0].trim()), 6);
    const lon = roundFloat(parseFloat(parts[1].trim()), 6);
    return {lat, lon};
  }
  if(isValidSpaceFormat(str)){
    const parts = str.trim().split(/\s+/);
    const lat = roundFloat(parseFloat(parts[0]), 6);
    const lon = roundFloat(parseFloat(parts[1]), 6);
    return {lat, lon};
  }
  return undefined;
}

/**
 * Проверяет формат с запятой: "59.913106, 30.328730"
 */
function isValidCommaFormat(str) {
  const parts = str.split(',');
  if (parts.length !== 2) return false;

  const [latStr, lngStr] = parts.map(part => part.trim());
  return areValidCoordinateParts(latStr, lngStr);
}

/**
 * Проверяет формат с пробелом: "59.913106 30.328730"
 */
function isValidSpaceFormat(str) {
  // Разделяем по пробелам, но учитываем, что числа могут быть отрицательными
  const parts = str.trim().split(/\s+/);
  if (parts.length !== 2) return false;

  const [latStr, lngStr] = parts;
  return areValidCoordinateParts(latStr, lngStr);
}

/**
 * Проверяет две части координат на валидность
 */
function areValidCoordinateParts(latStr, lngStr) {
  if (!isNumeric(latStr) || !isNumeric(lngStr)) return false;

  const lat = parseFloat(latStr);
  const lng = parseFloat(lngStr);

  return isValidLatitude(lat) && isValidLongitude(lng);
}

/**
 * Проверяет, является ли значение числом
 */
function isNumeric(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
}

/**
 * Проверяет валидность широты (-90 до 90)
 */
function isValidLatitude(lat) {
  return typeof lat === 'number' && lat >= -90 && lat <= 90;
}

/**
 * Проверяет валидность долготы (-180 до 180)
 */
function isValidLongitude(lng) {
  return typeof lng === 'number' && lng >= -180 && lng <= 180;
}